module.exports = "../../static/pages/AppPrivacyPolicy.html";


//////////////////
// WEBPACK FOOTER
// ./static/pages/AppPrivacyPolicy.html
// module id = 764
// module chunks = 1